module.exports = __webpack_public_path__ + "img/stripe.51169a9e.svg";